import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';

import { TrlChevronArrow } from '»components/atoms';
import { getTopInstrumentSubStrLabel } from '»utils/string';

import {
  CheckIconStyled,
  getPaperPropsStyles,
  MainContainer,
  MenuItemStyled,
  SelectStyled,
  TextStyled,
  TitleContainer,
} from './TrlSectionTitle.styles';

const getArrow = (props) => <TrlChevronArrow {...props} />;

export const TrlSectionTitle = ({
  title,
  hasPadding,
  hasBackground,
  hasMarginBottom,
  noBorderBottom,
  noPaddingBottom,
  currentValue,
  options,
  handleChangeOption,
  otherBackgroundColor,
  isTopInstrumentsOptions,
}) => {
  const theme = useTheme();

  const [isOpen, setIsOpen] = useState(false);

  const handleIsOpen = () => {
    setIsOpen((prevValue) => !prevValue);
  };

  return (
    <MainContainer
      hasBackground={hasBackground}
      hasMarginBottom={hasMarginBottom}
      hasPadding={hasPadding}
      backgroundColor={otherBackgroundColor}
    >
      <TitleContainer
        noBorderBottom={noBorderBottom}
        noPaddingBottom={noPaddingBottom}
      >
        {currentValue && options?.length > 0 ? (
          <SelectStyled
            value={currentValue}
            MenuProps={{
              PaperProps: {
                sx: getPaperPropsStyles(theme),
              },
            }}
            open={isOpen}
            onOpen={handleIsOpen}
            onClose={handleIsOpen}
            IconComponent={getArrow}
            onChange={(e) => {
              handleChangeOption(e.target.value);
            }}
            renderValue={(value) =>
              options.find((option) => option.value === value).label
            }
          >
            {options.map((option) => (
              <MenuItemStyled key={option.value} value={option.value}>
                {isTopInstrumentsOptions
                  ? getTopInstrumentSubStrLabel(option.label)
                  : option.label}
                <CheckIconStyled icon={faCheck} />
              </MenuItemStyled>
            ))}
          </SelectStyled>
        ) : (
          <TextStyled>{title}</TextStyled>
        )}
      </TitleContainer>
    </MainContainer>
  );
};

TrlSectionTitle.propTypes = {
  title: PropTypes.string,
  hasPadding: PropTypes.bool,
  hasBackground: PropTypes.bool,
  hasMarginBottom: PropTypes.bool,
  noBorderBottom: PropTypes.bool,
  noPaddingBottom: PropTypes.bool,
  currentValue: PropTypes.string,
  options: PropTypes.array,
  handleChangeOption: PropTypes.func,
  otherBackgroundColor: PropTypes.string,
  isTopInstrumentsOptions: PropTypes.bool,
};
